/* Auto-load the next page of results in place of numbered pagination.
   Markup contract (rendered by main-an-collection / main-an-search / an-blog):
     <div data-autoload-grid> …cards… </div>
     <a data-autoload href="<next page url>">Loading more</a>
   The sentinel is a real link, so crawlers and no-JS visitors still get
   working pagination. JS fetches the next page's HTML, moves the fetched
   grid's children into the on-screen grid, then adopts the fetched page's
   own sentinel URL until pages run out. Quick-add keeps working on the
   appended cards because an-cart.js delegates [data-quick-add] on document. */
(function () {
  var sentinel = document.querySelector('[data-autoload]');
  var grid = document.querySelector('[data-autoload-grid]');
  if (!sentinel || !grid) return;
  var busy = false;
  var io = null;

  function done() {
    if (io) io.disconnect();
    if (sentinel) { sentinel.remove(); sentinel = null; }
  }

  function load() {
    if (busy || !sentinel) return;
    busy = true;
    var url = sentinel.getAttribute('href');
    sentinel.classList.add('loading');
    fetch(url, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { if (!r.ok) throw new Error('autoload ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.querySelector('[data-autoload-grid]');
        if (nextGrid) {
          while (nextGrid.firstElementChild) grid.appendChild(nextGrid.firstElementChild);
        }
        var nextSentinel = doc.querySelector('[data-autoload]');
        var nextUrl = nextSentinel && nextSentinel.getAttribute('href');
        if (nextUrl && nextUrl !== url) sentinel.setAttribute('href', nextUrl);
        else done();
      })
      .catch(function () { /* leave the sentinel as a plain next-page link */ })
      .finally(function () {
        busy = false;
        if (!sentinel) return;
        sentinel.classList.remove('loading');
        // Short viewports: if the sentinel is still near the screen, keep going.
        var top = sentinel.getBoundingClientRect().top;
        if (top < window.innerHeight + 600) load();
      });
  }

  sentinel.addEventListener('click', function (e) { e.preventDefault(); load(); });

  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) load();
    }, { rootMargin: '900px 0px' });
    io.observe(sentinel);
  }
})();
